function productsSection() {
  const productSections = document.querySelectorAll('.products');
  
  productSections.forEach(section => {
    const body = document.querySelector('body');
    const sliderWrapperBg = section.querySelector('.slider-wrapper-products__bg')
    const sliderWrapper = section.querySelector('.slider-wrapper-products');
    const openButtons = section.querySelectorAll('.product-item');
    const closeButtons = section.querySelectorAll('.product-slide .product-slide__close .wp-element-button');

    openButtons.forEach((button, index) => {
      button.addEventListener('click', function(e) {
        e.preventDefault();

        if (sliderWrapper) {
          body.classList.add('overflow-hidden');
          sliderWrapper.classList.add('slider-wrapper-products--open');
          sliderProducts(sliderWrapper, index);
        }
      });
    });

    closeButtons.forEach(buttonClose => {
      buttonClose.addEventListener('click', function(e) {
        e.preventDefault();

        if (sliderWrapper) {
          body.classList.remove('overflow-hidden');
          sliderWrapper.classList.remove('slider-wrapper-products--open');
        }
      });
    });
    
    sliderWrapperBg.addEventListener('click', function(e) {
      if (sliderWrapper) {
        body.classList.remove('overflow-hidden');
        sliderWrapper.classList.remove('slider-wrapper-products--open');
      }
    })
  });
}

function sliderProducts(wrapper, startIndex) {
  const sliders = wrapper.querySelectorAll('.slider-wrapper-products .splide');
  sliders.forEach(sliderProducts => {
    let splideInstanceTestimonials;

    const mobileSpeed = parseInt(wrapper.dataset.mobileSpeed) || 1000;
    const desktopSpeed = parseInt(wrapper.dataset.desktopSpeed) || 1000;

    const initSliderProducts = () => {
      if (splideInstanceTestimonials) {
        splideInstanceTestimonials.destroy();
      }

      splideInstanceTestimonials = new Splide(sliderProducts, {
        type: 'fade',
        speed: window.innerWidth < 1024 ? mobileSpeed : desktopSpeed,
        perPage: 1,
        perMove: 1,
        gap: '1.5rem',
        autoHeight: true,
        lazyload: 'sequential',
        rewind: true,
        mediaQuery: 'min',
        pagination: false,
        autoplay: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        interval: 7000,
        focusableNodes: true,
        easing: 'linear',
        start: startIndex,
        breakpoints: {
          1024: {
            perPage: 1,
            perMove: 1,
            pagination: false,
            width: '71.8125rem',
            autoplay: false,
            rewind: false,
            easing: 'ease-in-out'
          }
        }
      });

      splideInstanceTestimonials.mount();
    };

    initSliderProducts();
    window.addEventListener('resize', initSliderProducts);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  productsSection();
});
